module.exports = __webpack_public_path__ + "img/public-health.8a689156.jpg";